// Single source of truth for the marketing volume claim (English surfaces).
//
// HONESTY RULE (2026-07-11): only verifiable claims, ever. The old synthetic
// lifetime counter (89,253 + 100/day) is gone — do not bring it back, and do
// not add any count this site can't back with Gizmo/Firestore data.
//
// The weekly floor must stay at or below what Gizmo actually measures
// (color-analysis quiz completes + photo uploads; ~490/wk at the 07-10
// baseline). If measured volume drops below the floor, lower the floor.
//
// Localized surfaces carry translated copies of this exact claim in
// messages/*.json under aiColorAnalysis.landing.weeklyProof — keep the number
// in sync across both when it changes.
export const WEEKLY_ANALYSES_FLOOR = 450;

export function weeklyAnalysesClaim(): string {
  return `${WEEKLY_ANALYSES_FLOOR}+ color analyses run every week`;
}
